import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { POST_COMMENTS_KEY } from "./useComments";

// Types
export interface CommentReactionData {
    commentId: number;
    type: "like" | "celebrate" | "support" | "insightful" | "funny";
}

export interface CommentReactionResponse {
    success: boolean;
    action: "added" | "removed";
    reaction: {
        id: number;
        type: string;
        createdAt: string;
    } | null;
    reactionSummary: Record<string, number>;
    totalReactions: number;
}

// Toggle comment reaction (like/unlike)
export const useToggleCommentReaction = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ commentId, type }: CommentReactionData) => {
            const response = await loggedInApiCall.post(`/api/comments/${commentId}/react`, { type });
            return response.data as CommentReactionResponse;
        },
        onSuccess: (reactionResponse, { commentId }) => {
            // Invalidate all comment queries to refresh comments with updated reactions
            queryClient.invalidateQueries({ queryKey: [POST_COMMENTS_KEY] });

            console.info("Comment reaction toggled successfully:", reactionResponse);
        },
        onError: (error) => {
            console.error("Failed to toggle comment reaction:", error);
        },
    });
};
